var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPinUtglNative = function SvgPinUtglNative(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 6,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.594 5.5h1.02l-.09-1.832 1.672.994.512-.824L3.933 3l1.775-.838-.512-.824-1.672.994L3.614.5h-1.02l.09 1.832-1.672-.994-.512.824L2.275 3 .5 3.838l.512.824 1.672-.994-.09 1.832ZM16.387 5.5h1.019l-.09-1.832 1.672.994.512-.824L17.725 3l1.775-.838-.512-.824-1.672.994.09-1.832h-1.02l.09 1.832-1.672-.994-.512.824L16.067 3l-1.775.838.512.824 1.672-.994-.09 1.832Z",
    fill: "#305992"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49 5.5h1.02l-.09-1.832 1.672.994.512-.824L10.829 3l1.775-.838-.512-.824-1.672.994L10.51.5H9.49l.09 1.832-1.672-.994-.512.824L9.171 3l-1.775.838.512.824 1.672-.994L9.49 5.5Z",
    fill: "#CC8528"
  })));
};
export default SvgPinUtglNative;